export default __webpack_public_path__ + "static/media/food-beverage.8208e935.svg";